import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function Accordion({
  title,
  subtitle,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-341">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between bg-gradient-to-r from-green-50 to-white hover:from-green-100 hover:to-green-50 transition-colors" data-id="element-342">
        <div className="text-left" data-id="element-343">
          <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-344">
            {title}
          </h3>
          {subtitle && <p className="text-sm text-gray-600 mt-1" data-id="element-345">{subtitle}</p>}
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-346">
          <ChevronDownIcon className="w-6 h-6 text-emerald-500" data-id="element-347" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-348">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-349">
            <div className="px-6 py-4 bg-white" data-id="element-350">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}